import { CoreMenu } from '@core/types';

export const internshipSecretaryMenu: CoreMenu[] = [
	{
		id: 'internship-secretary-home',
		title: 'Dashboard',
		translate: 'menu_is_dashboard',
		type: 'item',
		icon: 'home',
		url: 'internship-secretary',
		exactMatch: true,
		permissions: ['internship.dashboard.view'],
	},
	{
		id: 'agenda',
		title: 'Agenda',
		translate: 'menu_is_agenda',
		type: 'item',
		icon: 'calendar',
		url: 'internship-secretary/agenda',
		permissions: ['internship.agenda.view'],
	},
	{
		id: 'tirocini',
		title: 'Tirocini',
		translate: 'menu_is_internships',
		type: 'collapsible',
		icon: 'briefcase',
		children: [
			{
				id: 'bookings',
				title: 'Prenotazioni',
				translate: 'menu_is_bookings',
				type: 'item',
				url: 'internship-secretary/bookings',
				permissions: ['internship.bookings.view'],
			},
			{
				id: 'tutor-assignments',
				title: 'Assegnazione Tutor',
				translate: 'menu_is_tutor_assignments',
				type: 'item',
				url: 'internship-secretary/tutor-assignments',
			},
		],
	},
	{
		id: 'network-management',
		title: 'Rete Formativa',
		translate: 'menu_is_training_network',
		type: 'collapsible',
		icon: 'layer-group',
		permissions: ['internship.network.view'],
		children: [
			{
				id: 'aziende',
				title: 'Aziende',
				translate: 'menu_is_companies',
				type: 'item',
				url: 'internship-secretary/companies',
			},
			{
				id: 'presidi',
				title: 'Presidi',
				translate: 'menu_is_locations',
				type: 'item',
				url: 'internship-secretary/locations',
			},
			{
				id: 'aree',
				title: 'Aree',
				translate: 'menu_is_areas',
				type: 'item',
				url: 'internship-secretary/areas',
			},
			{
				id: 'unita-operative',
				title: 'Unità Operative',
				translate: 'menu_is_operational_units',
				type: 'item',
				url: 'internship-secretary/operational-units',
			},
		],
	},
	{
		id: 'activities',
		title: 'Catalogo Attività',
		translate: 'menu_is_activities_catalog',
		type: 'item',
		icon: 'book',
		url: 'internship-secretary/activities',
		permissions: ['internship.activities.view'],
	},
	{
		id: 'students',
		title: 'Studenti',
		translate: 'menu_is_students',
		type: 'item',
		icon: 'user',
		url: 'internship-secretary/students',
		permissions: ['internship.users.view'],
	},
	{
		id: 'faq',
		title: 'FAQ',
		translate: 'menu_is_faq',
		type: 'item',
		icon: 'circle-question',
		url: 'internship-secretary/faq',
	},
	{
		id: 'users-management',
		title: 'Gestione Utenti',
		translate: 'menu_is_user_management',
		type: 'item',
		icon: 'users',
		url: 'internship-secretary/users',
		permissions: ['internship.users.view'],
	},
];
